import { render } from "./ClanBoostCard.vue?vue&type=template&id=1fab6d88&scoped=true"
import script from "./ClanBoostCard.vue?vue&type=script&lang=js"
export * from "./ClanBoostCard.vue?vue&type=script&lang=js"

import "./ClanBoostCard.vue?vue&type=style&index=0&id=1fab6d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fab6d88"]])

export default __exports__